import { View } from "extensions/marionette";

import template from "./categoryItemChild.jst";

export const CategoryItemChild = View.extend({
    className() {
        const temps = this.getOption("temps");
        if (temps.length) {
            const item = temps[0].values.filter((t) => t.value === this.model.get("value"));
            if (item.length) {
                if (item[0].operator === "=") {
                    return "category-child-item temp-included";
                }
                
                return "category-child-item temp-excluded";
            }
        }
        
        return "category-child-item";
    },
    template,
    events: {
        "click .category-item-action": "itemClicked"
    },
    
    itemClicked(e) {
        e.preventDefault();
        
        // Stop event propagation so parent won't catch it
        e.stopPropagation();
        
        const operator = e.currentTarget.classList.contains("exclude") ? "excluded" : "included";
        this.$el.addClass(`temp-${operator}`);
        this.triggerMethod("treeitem:selected", this.model, operator);
    }
});
